import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderTextField from "../inputs/renderTextField";
import PersonFormValidation from "../validation/forms/personFormValidator";
import Button from '@material-ui/core/Button';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from '@material-ui/core/MenuItem';
import FormSelectItemValidation from "../validation/forms/formSelectItemValidation";

const CriterionForm =  (props) =>{
  const {submitCriterion, handleSubmit, categories, departments, criterion, handleCancel} = props;
  return (
    <form onSubmit={handleSubmit(submitCriterion)}>
      <div className={'form-group'}>
        <Field
          validate={FormSelectItemValidation}
          name="departmentId"
          label={'Department'}
          component={RenderSelectField}
          required
          fullWidth
        >
          {
            departments.map( department => (
              <MenuItem value={department.id} key={department.id}>{department.name}</MenuItem>
            ))
          }
        </Field>
      </div>
      <div className={'form-group'}>
        <Field
          validate={FormSelectItemValidation}
          name="categoryId"
          label={'Category'}
          component={RenderSelectField}
          required
          fullWidth
        >
          {
            categories.map(category => (
              <MenuItem value={category.id} key={category.id}>{category.name}</MenuItem>
            ))
          }
        </Field>
      </div>
      <div className={'form-group'}>
        <Field name="name" label={'Name'} component={RenderTextField} type="text" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field min={"0"} step={"0.1"} name="weightOld" label={'Εξάμηνη βαρύτητα'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field min={"0"} step={"0.1"} name="weightNew" label={'Βαρύτητα νέων καταστημάτων'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field min={"0"} step={"0.1"} name="weightNewComing" label={'Βαρύτητα υφιστάμενων καταστημάτων'} component={RenderTextField} type="number" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field name="code" label={'Code'} component={RenderTextField} type="text" disabled fullWidth/>
      </div>
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {criterion.id?'Edit':'Create'}
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary">
          {'Cancel'}
        </Button>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'criterion',
  validate: PersonFormValidation,
})(CriterionForm);



// WEBPACK FOOTER //
// ./src/components/criterion/criterionForm.js